import { compile, closest, EventHandler, isNullOrUndefined, formatUnit } from '@syncfusion/ej2-base';
import { addClass, removeClass, createElement, remove, extend } from '@syncfusion/ej2-base';
import { Dialog, Popup, Tooltip } from '@syncfusion/ej2-popups';
import { Button } from '@syncfusion/ej2-buttons';
import { Input } from '@syncfusion/ej2-inputs';
import { Crud } from '../actions/crud';
import { timezoneData } from '../timezone/timezone';
import { FieldValidator } from './form-validator';
import * as event from '../base/constant';
import * as cls from '../base/css-constant';
import * as util from '../base/util';
var moreEventHeight = 20;
/**
 * Quick Popups interactions
 */
var QuickPopups = /** @class */ (function () {
    /**
     * Constructor for QuickPopups
     */
    function QuickPopups(parent) {
        this.isMultipleEventSelect = false;
        this.parent = parent;
        this.l10n = this.parent.localeObj;
        this.crudAction = new Crud(parent);
        this.fieldValidator = new FieldValidator(this.parent);
        this.render();
        this.addEventListener();
    }
    QuickPopups.prototype.render = function () {
        this.renderQuickPopup();
        this.renderQuickDialog();
        this.renderMoreEventPopup();
        this.renderEventPopup();
    };
    QuickPopups.prototype.renderQuickPopup = function () {
        this.quickPopup = new Tooltip({
            animation: { open: { effect: 'FadeIn' }, close: { effect: 'FadeOut' } },
            afterOpen: this.afterQuickPopupOpen.bind(this),
            beforeOpen: this.beforeQuickPopupOpen.bind(this),
            beforeClose: this.beforeQuickPopupClose.bind(this),
            afterClose: this.afterQuickPopupClose.bind(this),
            cssClass: cls.QUICK_POPUP_ROOT_CLASS,
            enableRtl: this.parent.enableRtl, isSticky: true,
            opensOn: 'Custom',
            showTipPointer: false
        });
        this.quickPopup.appendTo(this.parent.element);
        this.primaryButton = new Button({
            cssClass: 'e-primary',
            disabled: this.parent.activeViewOptions.readonly,
            enableRtl: this.parent.enableRtl
        });
        this.flatButton = new Button({
            cssClass: 'e-flat',
            disabled: this.parent.activeViewOptions.readonly,
            enableRtl: this.parent.enableRtl
        });
    };
    QuickPopups.prototype.renderQuickDialog = function () {
        this.quickDialog = new Dialog({
            animationSettings: { effect: 'Zoom' },
            buttons: [
                { buttonModel: { isPrimary: true }, click: this.dialogButtonClick.bind(this) },
                { buttonModel: { isPrimary: false }, click: this.dialogButtonClick.bind(this) }
            ],
            cssClass: cls.QUICK_DIALOG_CLASS,
            closeOnEscape: true,
            enableRtl: this.parent.enableRtl,
            beforeClose: this.beforeQuickDialogClose.bind(this),
            isModal: true,
            position: { X: 'center', Y: 'center' },
            showCloseIcon: true,
            target: document.body,
            visible: false,
            width: 'auto'
        });
        var dialogElement = createElement('div', { id: this.parent.element.id + 'QuickDialog' });
        this.parent.element.appendChild(dialogElement);
        this.quickDialog.appendTo(dialogElement);
    };
    QuickPopups.prototype.renderMoreEventPopup = function () {
        var moreEventWrapper = createElement('div', { className: cls.MORE_POPUP_WRAPPER_CLASS + ' e-popup-close' });
        this.parent.element.appendChild(moreEventWrapper);
        var moreEventHeader = '<div class="${classList[0]}"><div class="${classList[1]}">' +
            '<div class="${classList[2]}" tabindex="0"><div class="${classList[3]}"></div>' +
            '<div class="${classList[4]}" tabindex="0"></div></div>' +
            '<div class="${classList[5]}" title="${l10n.close}" tabindex="0"></div></div></div>';
        var moreEventArgs = {
            classList: [
                cls.MORE_EVENT_POPUP_CLASS, cls.MORE_EVENT_HEADER_CLASS, cls.MORE_EVENT_DATE_HEADER_CLASS,
                cls.MORE_EVENT_HEADER_DAY_CLASS, cls.MORE_EVENT_HEADER_DATE_CLASS + ' ' + cls.NAVIGATE_CLASS, cls.MORE_EVENT_CLOSE_CLASS
            ],
            l10n: { close: this.l10n.getConstant('close'), noTitle: this.l10n.getConstant('noTitle') }
        };
        var moreEventContent = compile(moreEventHeader)(moreEventArgs)[0];
        this.morePopup = new Popup(moreEventWrapper, {
            targetType: 'relative',
            content: moreEventContent,
            enableRtl: this.parent.enableRtl,
            hideAnimation: { name: 'ZoomOut', duration: 300 },
            showAnimation: { name: 'ZoomIn', duration: 300 },
            open: this.afterMorePopupOpen.bind(this),
            close: this.afterMorePopupClose.bind(this),
            collision: { X: 'flip', Y: 'flip' },
            viewPortElement: this.parent.element.querySelector('.' + cls.TABLE_CONTAINER_CLASS),
            zIndex: 10
        });
        var closeButton = new Button({ iconCss: 'e-icons e-close-icon', cssClass: 'e-round', isPrimary: false });
        closeButton.appendTo(moreEventContent.querySelector('.' + cls.MORE_EVENT_CLOSE_CLASS));
        EventHandler.add(moreEventContent.querySelector('.' + cls.MORE_EVENT_CLOSE_CLASS), 'click', this.closeClick, this);
        EventHandler.add(moreEventContent.querySelector('.' + cls.MORE_EVENT_HEADER_DATE_CLASS), 'click', this.dayNavigationClick, this);
    };
    QuickPopups.prototype.dayNavigationClick = function (e) {
        var navigateEle = closest(e.target, '.' + cls.NAVIGATE_CLASS);
        if (!isNullOrUndefined(navigateEle)) {
            var date = this.parent.getDateFromElement(e.currentTarget);
            if (!isNullOrUndefined(date) && !this.parent.isAdaptive) {
                this.closeClick();
                this.parent.setProperties({ selectedDate: date }, true);
                this.parent.changeView('Day');
            }
        }
    };
    QuickPopups.prototype.renderEventPopup = function () {
        var viewHeight = document.body.offsetHeight;
        var toolBarHeight = this.parent.element.querySelector('.' + cls.TOOLBAR_CONTAINER);
        var eventWrapper = createElement('div', {
            className: cls.SELECT_POPUP_WRAPPER_CLASS + ' e-popup-close'
        });
        this.parent.element.appendChild(eventWrapper);
        var eventTemplate = '<div id="${id}EventDetailsWindow" class="${classList[0]}">' +
            '<div class="${classList[1]}">' +
            '<div class="${classList[23]}"><div class="${classList[24]}">' +
            '<div class="${classList[2]} ${classList[5]}" title="${l10n.close}" tabindex="0"></div></div>' +
            '<div class="${classList[25]}"><div class="${classList[3]} ${classList[5]}" title="${l10n.editEvent}" tabindex="0"></div>' +
            '<div class="${classList[4]} ${classList[5]}" title="${l10n.delete}" tabindex="0"></div></div></div>' +
            '<div class="${classList[6]} ${classList[7]}"></div></div>' +
            '<div class="${classList[9]}">' +
            '<div class="${classList[11]}"><div class="${classList[10]} ${classList[5]}"></div>' +
            '<div class="${classList[8]} ${classList[7]}">' +
            '<div class="${classList[26]} ${classList[7]}"></div><div class="${classList[27]} ${classList[7]}"></div></div></div>' +
            '<div class="${classList[14]}"><div class="${classList[15]} ${classList[5]}"></div>' +
            '<div class="${classList[16]} ${classList[7]}"></div></div>' +
            '<div class="${classList[17]}"><div class="${classList[18]} ${classList[5]}"></div>' +
            '<div class="${classList[19]} ${classList[7]}"></div></div>' +
            '<div class="${classList[20]}"><div class="${classList[21]} ${classList[5]}"></div>' +
            '<div class="${classList[22]} ${classList[7]}"></div></div></div>';
        var eventSelectTemplate = '<div id="${id}EventDetailsWindow" class="${classList[0]} ${classList[13]}">' +
            '<div class="${classList[1]}"><tbody>' +
            '<div class="${classList[2]} ${classList[5]}" title="${l10n.close}" tabindex="0"></div>' +
            '<div class="${classList[12]}"></div>' +
            '<div class="${classList[3]} ${classList[5]}" title="${l10n.editEvent}" tabindex="0"></div>' +
            '<div class="${classList[4]} ${classList[5]}" title="${l10n.delete}" tabindex="0"></div></div>';
        var eventArgs = {
            classList: [
                cls.QUICK_POPUP_CLASS, cls.QUICK_POPUP_TABLE_CLASS, cls.SELECTED_EVENT_CLOSE_CLASS,
                cls.SELECTED_EVENT_EDIT_CLASS, cls.SELECTED_EVENT_DELETE_CLASS, cls.ICON,
                cls.QUICK_POPUP_EVENT_TITLE_CLASS, cls.QUICK_POPUP_TEXT_ALIGN_CLASS, cls.QUICK_POPUP_DATE_TIME_DETAILS_CLASS,
                cls.QUICK_POPUP_CONTENT_CLASS, cls.SELECTED_DATE_TIME_CLASS, cls.APPOINTMENT_TIME, cls.SELECTED_EVENT_TITLE_CLASS,
                cls.SELECTED_EVENT_CONTAINER_CLASS, cls.APPOINTMENT_LOCATION, cls.SELECTED_CALENDER_CLASS,
                cls.QUICK_POPUP_LOCATION_DETAILS_CLASS, cls.EVENT_WINDOW_TZ_CLASS, cls.EVENT_TIME_ZONE_CLASS,
                cls.EVENT_ZONE_DETAILS_CLASS, cls.EVENT_DETAILS_CLASS, cls.EVENT_NOTE_CLASS, cls.EVENT_NOTE_DETAILS_CLASS,
                cls.QUICK_POPUP_ICON_CLASS, cls.QUICK_POPUP_CLOSE_ICON_CLASS, cls.QUICK_POPUP_EDIT_ICON_CLASS,
                cls.DEVICE_DATE_TIME_DETAILS_CLASS, cls.DEVICE_RECURRENCE_SUMMARY_CLASS
            ],
            id: this.parent.element.id,
            l10n: {
                close: this.l10n.getConstant('closeButton'),
                delete: this.l10n.getConstant('delete'),
                editSeries: this.l10n.getConstant('editSeries'),
                editEvent: this.l10n.getConstant('editEvent')
            }
        };
        this.selectedEventPopup = compile(eventTemplate)(eventArgs)[0];
        this.multipleEventPopup = compile(eventSelectTemplate)(eventArgs)[0];
        this.eventPopup = new Popup(eventWrapper, {
            targetType: 'relative',
            content: this.selectedEventPopup,
            collision: { X: 'fit', Y: 'fit' },
            enableRtl: this.parent.enableRtl,
            hideAnimation: { name: 'ZoomOut' },
            showAnimation: { name: 'ZoomIn' },
            relateTo: document.body
        });
        eventWrapper.querySelector('.' + cls.QUICK_POPUP_TABLE_CLASS).style.height = formatUnit((viewHeight * 25) / 100);
        eventWrapper.querySelector('.' + cls.QUICK_POPUP_CONTENT_CLASS).style.height = formatUnit((viewHeight * 75) / 100);
        EventHandler.add(this.selectedEventPopup.querySelector('.' + cls.SELECTED_EVENT_CLOSE_CLASS), 'click', this.closeClick, this);
        EventHandler.add(this.selectedEventPopup.querySelector('.' + cls.SELECTED_EVENT_EDIT_CLASS), 'click', this.editClick, this);
        EventHandler.add(this.selectedEventPopup.querySelector('.' + cls.SELECTED_EVENT_DELETE_CLASS), 'click', this.deleteClick, this);
        EventHandler.add(this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_CLOSE_CLASS), 'click', this.closeClick, this);
        EventHandler.add(this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_EDIT_CLASS), 'click', this.editClick, this);
        EventHandler.add(this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_DELETE_CLASS), 'click', this.deleteClick, this);
    };
    QuickPopups.prototype.openRecurrenceAlert = function () {
        var dialogFooter = this.quickDialog.element.querySelector('.' + cls.DIALOG_FOOTER_CONTENT_CLASS).children;
        dialogFooter[0].innerHTML = (this.parent.currentAction === 'Delete') ? this.l10n.getConstant('deleteEvent') :
            this.l10n.getConstant('editEvent');
        dialogFooter[1].innerHTML = (this.parent.currentAction === 'Delete') ? this.l10n.getConstant('deleteSeries') :
            this.l10n.getConstant('editSeries');
        this.quickDialog.content = (this.parent.currentAction === 'Delete') ? this.l10n.getConstant('deleteRecurrenceContent') :
            this.l10n.getConstant('editContent');
        this.quickDialog.header = (this.parent.currentAction === 'Delete') ? this.l10n.getConstant('deleteEvent') :
            this.l10n.getConstant('editEvent');
        this.quickDialogClass('Recurrence');
        this.showQuickDialog('RecurrenceAlert');
    };
    QuickPopups.prototype.openDeleteAlert = function () {
        var dialogFooter = this.quickDialog.element.querySelector('.' + cls.DIALOG_FOOTER_CONTENT_CLASS).children;
        dialogFooter[0].innerHTML = this.l10n.getConstant('delete');
        dialogFooter[1].innerHTML = this.l10n.getConstant('cancel');
        this.quickDialog.content = this.l10n.getConstant('deleteContent');
        this.quickDialog.header = this.l10n.getConstant('deleteEvent');
        this.quickDialogClass('Delete');
        this.showQuickDialog('DeleteAlert');
    };
    QuickPopups.prototype.openValidationError = function (type) {
        this.quickDialog.header = this.l10n.getConstant('alert');
        this.quickDialog.content = this.l10n.getConstant(type);
        var dialogFooter = this.quickDialog.element.querySelector('.' + cls.DIALOG_FOOTER_CONTENT_CLASS).children;
        dialogFooter[0].innerHTML = this.l10n.getConstant('ok');
        dialogFooter[1].innerHTML = this.l10n.getConstant('cancel');
        this.quickDialogClass('Alert');
        this.showQuickDialog('ValidationAlert');
    };
    QuickPopups.prototype.showQuickDialog = function (popupType) {
        this.quickDialog.dataBind();
        var eventProp = {
            type: popupType, cancel: false, data: this.parent.activeEventData,
            element: this.quickDialog.element
        };
        this.parent.trigger(event.popupOpen, eventProp);
        if (eventProp.cancel) {
            return;
        }
        this.quickDialog.show();
    };
    QuickPopups.prototype.createMoreEventList = function (events) {
        var fields = this.parent.eventFields;
        var moreEventContentEle = createElement('div', { className: cls.MORE_EVENT_CONTENT_CLASS });
        var moreEventWrapperEle = createElement('div', { className: cls.MORE_EVENT_WRAPPER_CLASS });
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            var appointmentEle = createElement('div', {
                id: '' + event_1[fields.id],
                className: cls.APPOINTMENT_CLASS,
                attrs: {
                    'data-guid': event_1.Guid,
                    'role': 'button', 'tabindex': '0', 'aria-readonly': 'false', 'aria-selected': 'false', 'aria-grabbed': 'true',
                    'aria-label': isNullOrUndefined(event_1[fields.subject]) ?
                        this.parent.eventSettings.fields.subject.default : event_1[fields.subject]
                }
            });
            appointmentEle.appendChild(createElement('div', {
                className: cls.APPOINTMENT_SUBJECT,
                innerHTML: event_1[fields.subject] || this.parent.eventSettings.fields.subject.default
            }));
            if (!isNullOrUndefined(event_1[fields.recurrenceRule])) {
                var iconClass = (event_1[fields.id] === event_1[fields.recurrenceID]) ?
                    cls.EVENT_RECURRENCE_ICON_CLASS : cls.EVENT_RECURRENCE_EDIT_ICON_CLASS;
                appointmentEle.appendChild(createElement('div', { className: cls.ICON + ' ' + iconClass }));
            }
            this.parent.eventBase.wireAppointmentEvents(appointmentEle);
            moreEventWrapperEle.appendChild(appointmentEle);
        }
        moreEventContentEle.appendChild(moreEventWrapperEle);
        return moreEventContentEle;
    };
    QuickPopups.prototype.eventHold = function (args) {
        var target = args.target;
        this.isMultipleEventSelect = false;
        if (!isNullOrUndefined(closest(target, '.' + cls.APPOINTMENT_CLASS)) && this.parent.isAdaptive) {
            target = closest(target, '.' + cls.APPOINTMENT_CLASS);
            this.parent.selectedElements = [];
            this.isMultipleEventSelect = true;
            this.selectedEventDialog(target);
            return;
        }
    };
    QuickPopups.prototype.cellClick = function (args) {
        if (!this.parent.showQuickInfo || this.parent.currentView === 'MonthAgenda') {
            return;
        }
        var target = closest(args.event.target, '.' + cls.WORK_CELLS_CLASS + ',.' +
            cls.ALLDAY_CELLS_CLASS + ',.' + cls.HEADER_CELLS_CLASS);
        if (isNullOrUndefined(target) || args.event.target.classList.contains(cls.MORE_INDICATOR_CLASS)) {
            return;
        }
        var timeDetails = this.parent.activeCellsData.isAllDay ? this.l10n.getConstant('allDay') :
            this.getDateFormat(this.parent.activeCellsData.startTime, 'hm') + ' - ' +
                this.getDateFormat(this.parent.activeCellsData.endTime, 'hm');
        var temp = {};
        temp[this.parent.eventFields.startTime] = this.parent.activeCellsData.startTime;
        temp[this.parent.eventFields.endTime] = this.parent.activeCellsData.endTime;
        temp[this.parent.eventFields.isAllDay] = this.parent.activeCellsData.isAllDay;
        var cellDetails = this.getFormattedString(temp, 'cell');
        var cellTemplate = '<div id="${id}EventCreateWindow" class="${classList[0]}"><table class="${classList[1]}"><tbody>' +
            '<tr><td><form class="${classList[2]}" onsubmit="return false;">' +
            '<input class="${classList[3]}" type="text" name="Subject" /></form></td></tr>' +
            '<tr><td><div class="${classList[4]} ${classList[8]}">' + cellDetails.details + '</div></td></tr>' +
            '</tbody></table><div class="${classList[5]}">' +
            '<div class="${classList[6]} ${classList[8]}" title="${l10n.moreDetails}" tabindex="0">${l10n.moreDetails}</div>' +
            '<div class="${classList[7]} ${classList[8]}" title="${l10n.save}" tabindex="0">${l10n.save}</div></div></div>';
        var cellArgs = {
            classList: [
                cls.QUICK_POPUP_CLASS, cls.QUICK_POPUP_TABLE_CLASS, cls.EVENT_WINDOW_FORM_CLASS, cls.QUICK_POPUP_SUBJECT_CLASS,
                cls.QUICK_POPUP_DATE_TIME_DETAILS_CLASS, cls.QUICK_POPUP_FOOTER_CLASS, cls.QUICK_POPUP_EVENT_DETAILS_CLASS,
                cls.QUICK_POPUP_EVENT_CREATE_CLASS, cls.QUICK_POPUP_TEXT_ALIGN_CLASS
            ],
            id: this.parent.element.id,
            l10n: {
                moreDetails: this.l10n.getConstant('moreDetails'),
                save: this.l10n.getConstant('save')
            }
        };
        var quickCellPopup = compile(cellTemplate)(cellArgs)[0];
        Input.createInput({
            element: quickCellPopup.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS),
            properties: { placeholder: this.l10n.getConstant('addTitle') }
        });
        this.flatButton.appendTo(quickCellPopup.querySelector('.' + cls.QUICK_POPUP_EVENT_DETAILS_CLASS));
        this.primaryButton.appendTo(quickCellPopup.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS));
        EventHandler.add(quickCellPopup.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS), 'click', this.saveClick, this);
        EventHandler.add(quickCellPopup.querySelector('.' + cls.QUICK_POPUP_EVENT_DETAILS_CLASS), 'click', this.detailsClick, this);
        this.quickPopup.content = quickCellPopup;
        this.quickPopup.target = '.' + cls.WORK_CELLS_CLASS;
        this.quickPopup.dataBind();
        this.applyFormValidation();
        if (this.morePopup) {
            this.morePopup.hide();
        }
        if (!this.parent.isAdaptive && target.getAttribute('data-tooltip-id') === null) {
            this.quickPopup.close();
            this.quickPopup.open(target);
        }
        else {
            quickCellPopup.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS).focus();
        }
    };
    QuickPopups.prototype.applyFormValidation = function () {
        var form = this.quickPopup.content
            .querySelector('.' + cls.EVENT_WINDOW_FORM_CLASS);
        var rules = {};
        rules[this.parent.eventSettings.fields.subject.name] = this.parent.eventSettings.fields.subject.validation;
        this.fieldValidator.renderFormValidator(form, rules);
    };
    QuickPopups.prototype.eventClick = function (events) {
        if (this.parent.eventTooltip) {
            this.parent.eventTooltip.close();
        }
        if (!this.parent.showQuickInfo) {
            return;
        }
        if (this.parent.isAdaptive) {
            if (this.isMultipleEventSelect) {
                this.selectedEventDialog(closest(events.element, '.' + cls.APPOINTMENT_CLASS));
            }
            else {
                this.deviceEventClick(events);
            }
        }
        else {
            var eventData = events.event;
            var args = this.getFormattedString(eventData, 'event');
            var eventTemplate = '<div id="${id}EventDetailsWindow" class="${classList[0]}"><table class="${classList[1]}"><tbody>' +
                '<tr><td><div class="${classList[2]} ${classList[7]}">' + args.eventSubject + '</div></td></tr>' +
                '<tr><td><div class="${classList[3]} ${classList[7]}">' + args.details + '</div></td></tr>' +
                '</tbody></table><div class="${classList[4]}">' +
                '<div class="${classList[5]} ${classList[7]}" title="${l10n.delete}" tabindex="0">${l10n.delete}</div>' +
                '<div class="${classList[6]} ${classList[7]}" title="${l10n.edit}" tabindex="0">${l10n.edit}</div></div></div>';
            var eventArgs = {
                classList: [
                    cls.QUICK_POPUP_CLASS, cls.QUICK_POPUP_TABLE_CLASS, cls.QUICK_POPUP_EVENT_TITLE_CLASS,
                    cls.QUICK_POPUP_DATE_TIME_DETAILS_CLASS, cls.QUICK_POPUP_FOOTER_CLASS, cls.QUICK_POPUP_DELETE_EVENT_CLASS,
                    cls.QUICK_POPUP_EDIT_EVENT_CLASS, cls.QUICK_POPUP_TEXT_ALIGN_CLASS
                ],
                id: this.parent.element.id,
                l10n: {
                    delete: this.l10n.getConstant('delete'),
                    edit: this.l10n.getConstant('edit')
                }
            };
            var quickEventPopup = compile(eventTemplate)(eventArgs)[0];
            this.flatButton.appendTo(quickEventPopup.querySelector('.' + cls.QUICK_POPUP_DELETE_EVENT_CLASS));
            this.primaryButton.appendTo(quickEventPopup.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS));
            EventHandler.add(quickEventPopup.querySelector('.' + cls.QUICK_POPUP_DELETE_EVENT_CLASS), 'click', this.deleteClick, this);
            EventHandler.add(quickEventPopup.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS), 'click', this.editClick, this);
            this.quickPopup.content = quickEventPopup;
            this.quickPopup.target = '.' + cls.APPOINTMENT_CLASS;
            this.quickPopup.dataBind();
            if (this.morePopup && !closest(events.element, '.' + cls.MORE_EVENT_WRAPPER_CLASS)) {
                this.morePopup.hide();
            }
            if (!this.parent.isAdaptive && events.element.getAttribute('data-tooltip-id') === null) {
                this.quickPopup.close();
                this.quickPopup.open(events.element);
            }
            else {
                this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS).focus();
            }
        }
    };
    QuickPopups.prototype.deviceEventClick = function (events) {
        var fields = this.parent.eventFields;
        var eventData = events.event;
        var eventSelectSubject = (isNullOrUndefined(eventData[fields.subject])) ?
            this.l10n.getConstant('noTitle') : eventData[fields.subject];
        var eventTimeDetails = (eventData[fields.isAllDay]) ? this.l10n.getConstant('allDay') :
            this.getDateFormat(eventData[fields.startTime], 'hm') + ' - ' +
                this.getDateFormat(eventData[fields.endTime], 'hm');
        var eventSelectDetails = this.getTimeDetails(eventData) + ' (' + eventTimeDetails + ')';
        this.selectedEventPopup.querySelector('.' + cls.QUICK_POPUP_EVENT_TITLE_CLASS).innerHTML = eventSelectSubject;
        this.selectedEventPopup.querySelector('.' + cls.DEVICE_DATE_TIME_DETAILS_CLASS).innerHTML = eventSelectDetails;
        this.selectedEventPopup.querySelector('.' + cls.QUICK_POPUP_LOCATION_DETAILS_CLASS).innerHTML =
            (!isNullOrUndefined(eventData[fields.location])) ? eventData[fields.location] : '';
        this.selectedEventPopup.querySelector('.' + cls.EVENT_ZONE_DETAILS_CLASS).innerHTML = this.getTimezone(eventData);
        this.selectedEventPopup.querySelector('.' + cls.EVENT_NOTE_DETAILS_CLASS).innerHTML =
            (!isNullOrUndefined(eventData[fields.description])) ? eventData[fields.description] : '';
        if (!isNullOrUndefined(eventData[fields.recurrenceRule])) {
            var recurrenceEditor = this.parent.eventWindow.getRecurrenceEditorInstance();
            var ruleSummary = recurrenceEditor.getRuleSummary(eventData[fields.recurrenceRule]);
            this.selectedEventPopup.querySelector('.' + cls.DEVICE_RECURRENCE_SUMMARY_CLASS).innerHTML =
                ruleSummary.charAt(0).toUpperCase() + ruleSummary.slice(1);
        }
        else {
            this.selectedEventPopup.querySelector('.' + cls.DEVICE_RECURRENCE_SUMMARY_CLASS).innerHTML = '';
        }
        if (isNullOrUndefined(eventData[fields.location]) || eventData[fields.location] === '') {
            addClass([this.selectedEventPopup.querySelector('.' + cls.APPOINTMENT_LOCATION)], cls.DISABLE_CLASS);
        }
        else {
            removeClass([this.selectedEventPopup.querySelector('.' + cls.APPOINTMENT_LOCATION)], cls.DISABLE_CLASS);
        }
        if (isNullOrUndefined(eventData[fields.startTimezone]) && isNullOrUndefined(eventData[fields.endTimezone])) {
            addClass([this.selectedEventPopup.querySelector('.' + cls.EVENT_WINDOW_TZ_CLASS)], cls.DISABLE_CLASS);
        }
        else {
            removeClass([this.selectedEventPopup.querySelector('.' + cls.EVENT_WINDOW_TZ_CLASS)], cls.DISABLE_CLASS);
        }
        if (isNullOrUndefined(eventData[fields.description]) || eventData[fields.description] === '') {
            addClass([this.selectedEventPopup.querySelector('.' + cls.EVENT_DETAILS_CLASS)], cls.DISABLE_CLASS);
        }
        else {
            removeClass([this.selectedEventPopup.querySelector('.' + cls.EVENT_DETAILS_CLASS)], cls.DISABLE_CLASS);
        }
        this.eventPopup.content = this.selectedEventPopup;
        if (this.eventPopup && !closest(events.element, '.' + cls.MORE_EVENT_WRAPPER_CLASS)) {
            this.showEventPopup('ViewEventInfo');
        }
    };
    QuickPopups.prototype.showEventPopup = function (popupType) {
        var eventProp = {
            type: popupType, cancel: false, data: this.parent.activeEventData.event,
            target: this.parent.activeEventData.element, element: this.eventPopup.element
        };
        this.parent.trigger(event.popupOpen, eventProp);
        if (eventProp.cancel) {
            return;
        }
        this.eventPopup.show();
    };
    QuickPopups.prototype.getFormattedString = function (eventData, type) {
        var fields = this.parent.eventFields;
        var eventSubject = isNullOrUndefined(eventData[fields.subject]) ? this.l10n.getConstant('noTitle') :
            eventData[fields.subject];
        var startDate = eventData[fields.startTime];
        var endDate = eventData[fields.endTime];
        var startDateDetails = this.getDateFormat(startDate, 'long');
        var endDateDetails = (eventData[fields.isAllDay] && endDate.getHours() === 0 && endDate.getMinutes() === 0) ?
            this.getDateFormat(util.addDays(new Date(endDate.getTime()), -1), 'long') : this.getDateFormat(endDate, 'long');
        var startTimeDetail = this.getDateFormat(startDate, 'hm');
        var endTimeDetail = this.getDateFormat(endDate, 'hm');
        var details;
        var allDayLength = (endDate.getTime() - startDate.getTime()) / util.MS_PER_DAY;
        var spanLength = endDate.getDate() !== startDate.getDate() &&
            (endDate.getTime() - startDate.getTime()) / (60 * 60 * 1000) < 24 ? 1 : 0;
        if (eventData[fields.isAllDay] || allDayLength >= 1 || spanLength > 0) {
            details = startDateDetails + ' (' +
                (eventData[fields.isAllDay] ? this.l10n.getConstant('allDay') : startTimeDetail) + ')';
            if (allDayLength > 1 || spanLength > 0) {
                details += '&nbsp;-&nbsp;' + endDateDetails + ' (' +
                    (eventData[fields.isAllDay] ? this.l10n.getConstant('allDay') : endTimeDetail) + ')';
            }
        }
        else {
            details = startDateDetails + ' (' + (startTimeDetail + '&nbsp;-&nbsp;' + endTimeDetail) + ')';
        }
        return { eventSubject: eventSubject, details: details };
    };
    QuickPopups.prototype.moreEventClick = function (data) {
        if (!this.parent.showQuickInfo) {
            return;
        }
        if (this.morePopup.element.querySelector('.' + cls.MORE_EVENT_CONTENT_CLASS)) {
            this.morePopup.element.querySelector('.' + cls.MORE_EVENT_CONTENT_CLASS).remove();
        }
        this.morePopup.element.children[0].appendChild(this.createMoreEventList(data.event));
        var selectedDate = ((data.date).getTime()).toString();
        var target = closest(data.element, '.' + cls.MORE_INDICATOR_CLASS);
        this.morePopup.element.querySelector('.' + cls.MORE_EVENT_HEADER_DAY_CLASS).innerHTML = this.getDateFormat(data.date, 'E');
        this.morePopup.element.querySelector('.' + cls.MORE_EVENT_HEADER_DATE_CLASS).innerHTML = this.getDateFormat(data.date, 'd');
        this.morePopup.element.querySelector('.' + cls.MORE_EVENT_HEADER_DATE_CLASS).setAttribute('data-date', selectedDate);
        this.morePopup.relateTo = closest(target, '.' + cls.WORK_CELLS_CLASS);
        var eventProp = { type: 'EventContainer', data: data, cancel: false, element: this.morePopup.element };
        this.parent.trigger(event.popupOpen, eventProp);
        if (eventProp.cancel) {
            return;
        }
        this.morePopup.show();
    };
    QuickPopups.prototype.saveClick = function () {
        if (!this.quickPopup.content.querySelector('.' + cls.EVENT_WINDOW_FORM_CLASS)
            .ej2_instances[0].validate()) {
            return;
        }
        this.quickPopup.close();
        var fields = this.parent.eventFields;
        var saveObj = {};
        saveObj[fields.id] = this.parent.eventBase.getEventMaxId() + 1;
        saveObj[fields.subject] =
            this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS).value ||
                this.parent.eventSettings.fields.subject.default;
        saveObj[fields.startTime] = this.parent.activeCellsData.startTime;
        saveObj[fields.endTime] = this.parent.activeCellsData.endTime;
        saveObj[fields.isAllDay] = this.parent.activeCellsData.isAllDay;
        this.crudAction.addEvent(saveObj);
    };
    QuickPopups.prototype.detailsClick = function () {
        var subject = this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS).value;
        if (subject !== '') {
            var args = extend(this.parent.activeCellsData, { subject: subject });
        }
        this.fieldValidator.destroyToolTip();
        this.quickPopup.close();
        this.parent.eventWindow.openEditor(this.parent.activeCellsData, 'Add');
    };
    QuickPopups.prototype.editClick = function (event) {
        this.quickPopup.close({ effect: 'None' });
        this.morePopup.hide();
        var data = this.parent.activeEventData.event;
        this.parent.currentAction = 'EditSeries';
        if (this.parent.isAdaptive) {
            this.eventPopup.hide();
            this.isMultipleEventSelect = false;
            if (!isNullOrUndefined(data[this.parent.eventFields.recurrenceRule])) {
                this.parent.currentAction = 'EditOccurrence';
                this.openRecurrenceAlert();
                return;
            }
        }
        if (!isNullOrUndefined(data[this.parent.eventFields.recurrenceRule])) {
            this.parent.currentAction = 'EditOccurrence';
            this.openRecurrenceAlert();
        }
        else {
            this.parent.eventWindow.openEditor(data, this.parent.currentAction);
        }
    };
    QuickPopups.prototype.deleteClick = function () {
        this.quickPopup.close({ effect: 'None' });
        this.morePopup.hide();
        if (this.parent.isAdaptive) {
            this.eventPopup.hide();
            this.isMultipleEventSelect = false;
        }
        this.parent.currentAction = 'Delete';
        if (this.parent.activeEventData.event[this.parent.eventFields.recurrenceRule]) {
            this.openRecurrenceAlert();
        }
        else {
            this.openDeleteAlert();
        }
    };
    QuickPopups.prototype.closeClick = function () {
        this.morePopup.hide();
        this.eventPopup.hide();
        this.isMultipleEventSelect = false;
    };
    QuickPopups.prototype.dialogButtonClick = function (event) {
        this.quickDialog.hide();
        if (event.target.classList.contains(cls.QUICK_DIALOG_EDIT_EVENT_CLASS)) {
            this.parent.currentAction = (this.parent.currentAction === 'Delete') ? 'DeleteOccurrence' : 'EditOccurrence';
            switch (this.parent.currentAction) {
                case 'EditOccurrence':
                    this.parent.eventWindow.openEditor(this.parent.activeEventData.event, this.parent.currentAction);
                    break;
                case 'DeleteOccurrence':
                    this.crudAction.deleteEvent(this.parent.activeEventData.event, this.parent.currentAction);
                    break;
            }
        }
        else if (event.target.classList.contains(cls.QUICK_DIALOG_EDIT_SERIES_CLASS)) {
            this.parent.currentAction = (this.parent.currentAction === 'Delete') ? 'DeleteSeries' : 'EditSeries';
            switch (this.parent.currentAction) {
                case 'EditSeries':
                    var parentEvent = this.parent.eventBase.getRecurrenceEvent(this.parent.activeEventData.event);
                    this.parent.eventWindow.openEditor(parentEvent, this.parent.currentAction);
                    break;
                case 'DeleteSeries':
                    this.crudAction.deleteEvent(this.parent.activeEventData.event, this.parent.currentAction);
                    break;
            }
        }
        else if (event.target.classList.contains(cls.QUICK_DIALOG_DELETE_CLASS)) {
            this.crudAction.deleteEvent(this.parent.activeEventData.event, this.parent.currentAction);
        }
    };
    QuickPopups.prototype.selectedEventDialog = function (target) {
        var selectedElements = this.parent.eventBase.getSelectedEventElements(target);
        this.parent.activeEventData = this.parent.eventBase.getSelectedEvents();
        if (selectedElements.length === 1) {
            this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_TITLE_CLASS).innerHTML =
                selectedElements[0].querySelector('.' + cls.APPOINTMENT_SUBJECT).textContent;
            removeClass([this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_EDIT_CLASS)], cls.EVENT_EDIT_DISABLE_CLASS);
            this.eventPopup.content = this.multipleEventPopup;
            if (this.eventPopup && !closest(target, '.' + cls.MORE_EVENT_WRAPPER_CLASS)) {
                this.showEventPopup('EditEventInfo');
            }
        }
        else if (selectedElements.length <= 0) {
            this.parent.selectedElements = [];
            this.isMultipleEventSelect = false;
            this.eventPopup.hide();
        }
        else if (selectedElements.length > 1) {
            this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_TITLE_CLASS).innerHTML =
                '(' + selectedElements.length.toString() + ')' + '&nbsp;' + this.l10n.getConstant('selectedItems');
            addClass([this.multipleEventPopup.querySelector('.' + cls.SELECTED_EVENT_EDIT_CLASS)], cls.EVENT_EDIT_DISABLE_CLASS);
        }
    };
    QuickPopups.prototype.getTimezone = function (event) {
        var fields = this.parent.eventFields;
        var zoneDetails = '';
        timezoneData.filter(function (zoneData) {
            if (!isNullOrUndefined(event[fields.startTimezone]) && zoneData.Value === event[fields.startTimezone]) {
                zoneDetails = zoneData.Text.split(') ')[0] + ')' + zoneDetails;
            }
            if (!isNullOrUndefined(event[fields.endTimezone]) && zoneData.Value === event[fields.endTimezone]) {
                zoneDetails = zoneDetails + '&nbsp;' + zoneData.Text.split(') ')[0] + ')';
            }
        });
        return zoneDetails;
    };
    QuickPopups.prototype.getTimeDetails = function (event) {
        var fields = this.parent.eventFields;
        var startDate = event[fields.startTime];
        var endDate = event[fields.endTime];
        var allDayLength = (endDate.getTime() - startDate.getTime()) / util.MS_PER_DAY;
        var timeDetails = '';
        if (this.getDateFormat(startDate, 'yMd') === this.getDateFormat(endDate, 'yMd') || (event[fields.isAllDay] && allDayLength === 1)) {
            timeDetails = this.parent.globalize.formatDate(startDate, { format: 'MMMM d, yyyy' });
        }
        else {
            timeDetails = this.parent.globalize.formatDate(startDate, { format: 'MMM dd' }) + ' - ' +
                this.parent.globalize.formatDate(endDate, { format: 'MMM dd, yyyy' });
        }
        return timeDetails;
    };
    QuickPopups.prototype.getDateFormat = function (date, formatString) {
        return this.parent.globalize.formatDate(date, { skeleton: formatString });
    };
    QuickPopups.prototype.afterQuickPopupOpen = function (args) {
        if (this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS)) {
            this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS).focus();
        }
        if (this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS)) {
            this.quickPopup.content.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS).focus();
        }
    };
    QuickPopups.prototype.beforeQuickPopupOpen = function (args) {
        args.element.querySelector('.' + cls.TOOLTIP_CLOSE_CLASS).setAttribute('title', this.l10n.getConstant('close'));
        EventHandler.add(args.element, 'keydown', this.keyPress, this);
        var eventProp = {
            type: 'QuickInfo', cancel: false, data: this.getDataFromTarget(args.target),
            target: args.target, element: args.element
        };
        this.parent.trigger(event.popupOpen, eventProp);
        if (eventProp.cancel) {
            args.cancel = true;
        }
    };
    QuickPopups.prototype.getDataFromTarget = function (target) {
        if (target.classList.contains(cls.APPOINTMENT_CLASS)) {
            return this.parent.activeEventData.event;
        }
        return this.parent.activeCellsData;
    };
    QuickPopups.prototype.beforeQuickPopupClose = function (args) {
        EventHandler.remove(args.element, 'keydown', this.keyPress);
    };
    QuickPopups.prototype.beforeQuickDialogClose = function (args) {
        this.parent.eventBase.focusElement();
    };
    QuickPopups.prototype.keyPress = function (event) {
        var popupElement = this.quickPopup.content;
        if (event.keyCode === 9) {
            var buttonObj = void 0;
            if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS) && !event.shiftKey) {
                event.preventDefault();
                (popupElement.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS)).focus();
            }
            if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS) && !event.shiftKey) {
                event.preventDefault();
                popupElement.querySelector('.' + cls.QUICK_POPUP_DELETE_EVENT_CLASS).focus();
            }
            if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS) && event.shiftKey) {
                event.preventDefault();
                popupElement.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS).focus();
            }
            if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_DELETE_EVENT_CLASS) && event.shiftKey) {
                event.preventDefault();
                popupElement.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS).focus();
            }
        }
        if (event.keyCode === 13) {
            if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_EVENT_DETAILS_CLASS)) {
                event.target.click();
            }
            else if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS) ||
                event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_EDIT_EVENT_CLASS) ||
                event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_DELETE_EVENT_CLASS)) {
                event.target.click();
            }
            else if (event.target === popupElement.querySelector('.' + cls.QUICK_POPUP_SUBJECT_CLASS)) {
                popupElement.querySelector('.' + cls.QUICK_POPUP_EVENT_CREATE_CLASS).click();
                event.preventDefault();
            }
        }
        if (event.keyCode === 27) {
            this.parent.quickPopup.onClosePopup();
        }
    };
    QuickPopups.prototype.afterMorePopupOpen = function (event) {
        var moreEventWrapper = this.parent.element.querySelector('.' + cls.MORE_POPUP_WRAPPER_CLASS);
        moreEventWrapper.querySelector('.' + cls.MORE_EVENT_HEADER_DATE_CLASS).focus();
        this.morePopup.refreshPosition();
    };
    QuickPopups.prototype.afterMorePopupClose = function (event) {
        //this.parent.eventBase.focusElement();
        if (!isNullOrUndefined(this.parent.element.querySelector('.' + cls.MORE_EVENT_WRAPPER_CLASS))) {
            (this.parent.element.querySelector('.' + cls.MORE_EVENT_WRAPPER_CLASS)).remove();
        }
    };
    QuickPopups.prototype.afterQuickPopupClose = function (args) {
        this.parent.eventBase.focusElement();
    };
    QuickPopups.prototype.quickDialogClass = function (action) {
        var buttonElement = this.quickDialog.element.querySelector('.' + cls.DIALOG_FOOTER_CONTENT_CLASS).children;
        var classList = [
            cls.QUICK_DIALOG_EDIT_EVENT_CLASS, cls.QUICK_DIALOG_EDIT_SERIES_CLASS,
            cls.QUICK_DIALOG_DELETE_CLASS, cls.QUICK_DIALOG_CANCEL_CLASS, cls.QUICK_DIALOG_ALERT_BTN_CLASS, cls.QUICK_DIALOG_HIDE_BTN_CLASS
        ];
        removeClass(buttonElement, classList);
        switch (action) {
            case 'Recurrence':
                addClass([buttonElement[0]], cls.QUICK_DIALOG_EDIT_EVENT_CLASS);
                addClass([buttonElement[1]], cls.QUICK_DIALOG_EDIT_SERIES_CLASS);
                addClass([buttonElement[1]], 'e-flat');
                break;
            case 'Delete':
                addClass([buttonElement[0]], cls.QUICK_DIALOG_DELETE_CLASS);
                addClass([buttonElement[1]], cls.QUICK_DIALOG_CANCEL_CLASS);
                removeClass([buttonElement[1]], 'e-flat');
                break;
            case 'Alert':
                addClass([buttonElement[0]], cls.QUICK_DIALOG_ALERT_BTN_CLASS);
                addClass([buttonElement[1]], cls.QUICK_DIALOG_HIDE_BTN_CLASS);
                break;
        }
    };
    QuickPopups.prototype.documentClick = function (e) {
        var target = e.event.target;
        if (!closest(target, '.' + cls.QUICK_POPUP_ROOT_CLASS) && target.getAttribute('data-tooltip-id') === null) {
            this.quickPopup.close();
        }
        if (!closest(target, '.' + cls.MORE_POPUP_WRAPPER_CLASS) && !target.classList.contains(cls.MORE_INDICATOR_CLASS)) {
            this.morePopup.hide();
        }
    };
    QuickPopups.prototype.onClosePopup = function () {
        this.quickPopup.close();
        this.eventPopup.hide();
        this.isMultipleEventSelect = false;
        this.parent.eventBase.focusElement();
    };
    QuickPopups.prototype.addEventListener = function () {
        this.parent.on(event.cellClick, this.cellClick, this);
        this.parent.on(event.eventClick, this.eventClick, this);
        this.parent.on(event.documentClick, this.documentClick, this);
    };
    QuickPopups.prototype.destroy = function () {
        this.quickPopup.destroy();
        this.morePopup.destroy();
        this.eventPopup.destroy();
        this.quickDialog.destroy();
        remove(this.quickDialog.element);
        this.quickDialog.element = null;
        this.fieldValidator.destroyForm();
    };
    return QuickPopups;
}());
export { QuickPopups };
